import { Box, Skeleton } from '@mui/material';
import React from 'react';

export const EmployerCommentsSkeletonCard = () => (
  <Box
    sx={{
      width: '100%',
      margin: '0 auto',
      padding: 2,
    }}
  >
    <Box
      sx={{
        border: '2px solid #019df2',
        borderRadius: '16px',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        position: 'relative',
      }}
    >
      {/* Date skeleton */}
      <Skeleton
        variant="rounded"
        width={80}
        height={24}
        sx={{
          backgroundColor: '#019df2',
          borderRadius: '6px',
          marginBottom: 2,
        }}
      />

      {/* Header/Title skeleton */}
      <Skeleton
        variant="rounded"
        width="70%"
        height={20}
        sx={{
          backgroundColor: '#d1d5db',
          borderRadius: '4px',
          marginBottom: 2,
        }}
      />

      {/* Content text lines */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={16}
        sx={{
          backgroundColor: '#d1d5db',
          borderRadius: '4px',
          marginBottom: 1,
        }}
      />
      <Skeleton
        variant="rounded"
        width="85%"
        height={16}
        sx={{
          backgroundColor: '#d1d5db',
          borderRadius: '4px',
          marginBottom: 1,
        }}
      />

      {/* Respond button skeleton */}
      <Skeleton
        variant="rounded"
        width={100}
        height={36}
        sx={{
          backgroundColor: '#019df2',
          borderRadius: '18px',
          position: 'absolute',
          right: '20px',
          top: '20px',
        }}
      />
    </Box>
  </Box>
);
